import React from "react";
import { Button, Spinner } from "react-bootstrap";
import CustomModal from "../../../Global/Modal/CustomModal";

const DisabledCoachesModal = ({
  show,
  onHide,
  coaches,
  onEnableCoach,
  loading,
}) => {
  const disabledCoaches =
    coaches?.filter((coach) => coach.userData.userStatus === "disabled") || [];

  const footerButtons = [
    {
      title: "סגור",
      style: "grey",
      onClick: onHide,
      disabled: loading,
    },
  ];

  return (
    <CustomModal
      isOpen={show}
      onClose={onHide}
      title="מאמנים מושבתים"
      footerButtons={footerButtons}
      width={60}
      height={70}
    >
      {disabledCoaches.length === 0 ? (
        <p className="text-center" style={{ fontSize: "1.5rem" }}>
          אין מאמנים מושבתים במערכת
        </p>
      ) : (
        <div className="coach-list" style={{ direction: "rtl" }}>
          {disabledCoaches.map((coach) => (
            <div key={coach.id} className="coach-item p-3 mb-2 border rounded">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">{coach.userData.userName}</h6>
                  <p className="mb-0 text-muted">
                    {coach.userData.userEmailAddress}
                  </p>
                </div>
                <Button
                  variant="success"
                  size="sm"
                  style={{
                    width: "100px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => onEnableCoach(coach)}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "החזר לפעילות"
                  )}
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CustomModal>
  );
};

export default DisabledCoachesModal;
